(() => {
  const MOBILE_QUERY = '(max-width: 749px)';

  function initMobileAtc(bar) {
    if (!bar || bar.dataset.mobileAtcReady === 'true') return;

    const source = document.getElementById(bar.dataset.sourceButton);
    const root = document.getElementById(bar.dataset.productRoot);
    const action = bar.querySelector('[data-mobile-atc-button]');
    const buyJump = bar.querySelector('[data-mobile-buy-jump]');
    const label = bar.querySelector('[data-mobile-atc-label]');
    const price = bar.querySelector('[data-mobile-atc-price]');
    const priceSource = root?.querySelector('[id^="price-"]');

    if (!source || !root || !action) return;

    bar.dataset.mobileAtcReady = 'true';
    bar.hidden = false;

    let sourceVisible = false;
    let ticking = false;

    const sync = () => {
      action.disabled = source.disabled || source.getAttribute('aria-disabled') === 'true';
      if (buyJump) buyJump.disabled = action.disabled;
      const sourceLabel = source.querySelector('span')?.textContent?.trim();
      if (sourceLabel && label) label.textContent = sourceLabel;

      const currentPrice = priceSource?.querySelector('.price-item--sale, .price-item--regular')?.textContent?.trim();
      if (currentPrice && price) price.textContent = currentPrice;
    };

    const updateVisibility = () => {
      ticking = false;
      const mobile = window.matchMedia(MOBILE_QUERY).matches;
      const rootBox = root.getBoundingClientRect();
      const info = root.querySelector('.product__info-wrapper');
      const infoBox = info?.getBoundingClientRect();
      const reachedProductInfo = infoBox ? infoBox.top < window.innerHeight * 0.72 : false;
      const insideProduct = rootBox.bottom > 96;
      const show = mobile && reachedProductInfo && insideProduct && !sourceVisible && !action.disabled && !document.body.classList.contains('overflow-hidden');
      bar.classList.toggle('is-visible', show);
    };

    const scheduleVisibility = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    };

    const observer = new MutationObserver(() => {
      sync();
      scheduleVisibility();
    });
    observer.observe(source, { attributes: true, childList: true, characterData: true, subtree: true });
    if (priceSource) observer.observe(priceSource, { childList: true, characterData: true, subtree: true });

    const intersection = new IntersectionObserver((entries) => {
      sourceVisible = entries[0]?.isIntersecting ?? false;
      scheduleVisibility();
    }, { threshold: 0.25 });
    intersection.observe(source);

    action.addEventListener('click', () => {
      if (!source.disabled && source.getAttribute('aria-disabled') !== 'true') source.click();
    });
    buyJump?.addEventListener('click', () => {
      const form = root.querySelector('product-form');
      const options = root.querySelector('variant-selects');
      const destination = options || form;
      if (!destination) return;
      destination.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      const focusTarget = options?.querySelector('select, input:checked:not(:disabled), input:not(:disabled)') || form?.querySelector('[data-bb-buy-now]:not(:disabled)') || source;
      focusTarget?.focus({ preventScroll: true });
    });
    const bodyObserver = new MutationObserver(scheduleVisibility);
    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    root.addEventListener('change', () => window.setTimeout(sync, 0));
    window.addEventListener('scroll', scheduleVisibility, { passive: true });
    window.addEventListener('resize', scheduleVisibility, { passive: true });

    sync();
    scheduleVisibility();
  }

  function initAll(scope = document) {
    scope.querySelectorAll('[data-mobile-sticky-atc]').forEach(initMobileAtc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

